import React, { Component } from "react";
import { connect } from "react-redux";

import screeningRemote from "../../api/screeningRemote";

import { receiveError } from "../../store/actions/notificationAction";

import ApiResponse from "../../models/ApiResponse";
import ResponseError from "../../models/ResponseError";
import Awb from "../../models/Awb";
import AwbParams from "../../models/AwbParams";

import validation from "../../utils/validation";
import { extractAwbCodeAndNumber } from "../../utils/airwayBill";
import AwbInfoSearchComponent from "../awbInfo/awbInfoSearch/AwbInfoSearchComponent";
import Button from "@material-ui/core/Button";
import ScreeningDetailsComponent from "./ScreeningDetails";

import screeningStyles from "./screeningDetails.module.css";
import commonStyles from '../common/common.module.css';

import User from "../../models/User";
import AttachmentsContainer from "../documentViewer/DocumentViewerContainer";
import GhaPickupStatusAwb from "../../models/GhaPickupStatusAwb";
import moment, { Moment } from "moment";
import ScreeningAwbInfoComponent from "./ScreeningAwbInfoComponent";
import Forwarder from "../../models/Forwarder";
import Screening, { PendingAwbs } from "../../models/Screening";
import ScreeningAwbDetails from "../../models/ScreeningAwbDetails";
import Exemption from "../../models/Exemptions";
import { History } from 'history';
import ScreeningResponse from "../../models/ScreeningResponse";
import PendingScreeningTable from "./PendingScreeningTable";
import { receiveButtonState } from "../../store/actions/disableApiCall";
import MultipleAwbs from "../awbInfo/MultipleAwbs";
import awbRemote from "../../api/awbRemote";
import OrderSelectionPopup from "./OrderSelectionPopup";

interface ScreeningDetailsContainerProps {
  receiveError: (error: ResponseError) => void;
  history: History;
  user: User;
  match: { params: { code: string, number: string, version: string, orderNumber: string } };
  setButtonState: (value: boolean) => void;
  buttonState: boolean;
};

interface ScreeningDetailsContainerState {
  awb: Array<Awb>;
  pickupOrders: Array<GhaPickupStatusAwb>;
  awbNumber: string;
  awbVersion: number;
  code: string;
  piecesSplit: Array<Screening>;
  forwarder: Forwarder;
  number: string;
  originDest: Array<KeyValue>;
  exportDetails: Array<KeyValue>;
  isAttachmentsDialogOpen: boolean;
  fullFlight: string;
  flight: string;
  exemptions: Exemption;
  measures: Array<string>;
  fromWarehouse: boolean;
  alarmResolutions: Array<string>;
  date: Moment;
  pendingAwbs: Array<PendingAwbs>;
  multipleAwbModal: boolean;
  multipleAwbs: Array<Awb>;
  selectedAwb: Awb;
  showOrderSelectionPopup: boolean;
  multipleOrders: Array<GhaPickupStatusAwb>;
  orderNumber: string;
  disableScreening: boolean;
  errorMessage?: string;
};

interface KeyValue {
  key: string;
  val: string;
};

class ScreeningDetailsContainer extends Component<ScreeningDetailsContainerProps, ScreeningDetailsContainerState> {

  state: ScreeningDetailsContainerState = {
    awb: [],
    forwarder: {} as Forwarder,
    pickupOrders: [],
    awbNumber: "",
    fullFlight: "",
    flight: "",
    piecesSplit: [],
    code: "",
    number: "",
    originDest: [],
    exemptions: {} as Exemption,
    measures: [],
    exportDetails: [],
    isAttachmentsDialogOpen: false,
    fromWarehouse: false,
    alarmResolutions: [],
    date: moment(),
    pendingAwbs: [],
    multipleAwbModal: false,
    multipleAwbs: [],
    awbVersion: 1,
    selectedAwb: {} as Awb,
    showOrderSelectionPopup: false,
    multipleOrders: [],
    orderNumber: '',
    disableScreening: false,
    errorMessage: ''
  };

  componentDidMount() {
    if (this.props.match.params.code && this.props.match.params.number) {
      this.setState({ awbNumber: this.props.match.params.code + '-' + this.props.match.params.number, awbVersion: Number(this.props.match.params.version), orderNumber: this.props.match.params.orderNumber, fromWarehouse: true }, () => {
        this.searchAwb();
      })
    }
    this.fetchPendingScreenings();
  }

  handleChangeAwb = (event: any): void => {
    let value: string = event.target.value.toString();
    if (value.length === 3 && this.state.awbNumber.length === 2) {
      value = value + "-";
    }
    if (value.length === 11) {
      if (value.indexOf("-") < 0) {
        value = value.slice(0, 3) + "-" + value.slice(3);
      }
    }
    if (value.split("-").length > 2) {
      value = value;
    }
    this.setState({ awbNumber: value });
  };

  handleSelectChange = (event: any, type: string): void => {
    this.setState({ errorMessage: '' });
    const id: number = event.target.id;
    const selectEl = event.target;
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    const value: string = event.target.value;
    if (type === 'details' && value === 'CCSF') {
      const ccsfType = (this.state.pickupOrders[0].ccsf_type || '').toLowerCase();

      if (ccsfType !== 'ccsf' && ccsfType !== 'ccsp') {
        this.setState({ errorMessage: 'The selected CCSF measure is not applicable for this AWB.' });
        return; // stop updating state
      }
    }
    if (type === 'details' && value === 'Received Screened from Interline') {
      const isInterline = this.state.awb[0].id_gha_interline; // <-- replace with real key

      if (!isInterline) {
        // show popup error
        this.setState({ errorMessage: 'This shipment is not an interline transfer.' });

        piecesSplit[id].screening_details = '';

        // refocus safely (avoid null target)
        setTimeout(() => {
          if (selectEl) selectEl.focus();
        }, 0);

        return; // stop further processing
      }
    }
    switch (type) {
      case 'measure':
        piecesSplit[id].measure_applied = value;
        break;
      case 'resolution':
        piecesSplit[id].alarm_resolution = value;
        break;
      case 'alarm':
        piecesSplit[id].alarm = !piecesSplit[id].alarm;
        break;
      default:
        piecesSplit[id].screening_details = value;
        break;
    }
    this.setState({ piecesSplit });
  }

  addCard = (): void => {
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit]
    const today: Date = new Date();
    let checked: boolean = true;
    let flight: string = this.state.awb[0].export_metadata.firstFlightNumber;
    let flightDate: any = moment(this.state.awb[0].export_metadata.firstFlightDate).format("DD MMM YY");
    if (this.state.flight === 'PO') {
      checked = false;
      flight = '';
      flightDate = null;
    }
    piecesSplit.push({
      pieces: 0,
      details: "",
      measure_applied: "",
      flight: flight,
      flightDate: flightDate,
      checked: checked,
      screening_details: "",
      date_time: moment(today).format("YYYYMMDD"),
      disabled: false,
      time: moment(today).format("HH:mm:ss"),
      screened_by: `${this.props.user.firstName} ${this.props.user.lastName}`,
      alarm: false,
      alarm_resolution: '',
      actual_weight: 0
    });
    this.setState({ piecesSplit });
  };

  changePieces = (event: any): void => {
    const id: number = event.target.id;
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    piecesSplit[id].pieces = event.target.value;
    this.setState({ piecesSplit });
  };

  changeText = (event: any, type: string): void => {
    const id: number = event.target.id;
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    switch (type) {
      case 'remarks':
        piecesSplit[id].details = event.target.value;
        break;
      case 'screener':
        piecesSplit[id].screened_by = event.target.value;
        break;
      case 'act_weight':
        piecesSplit[id].actual_weight = event.target.value;
        break;
      default:
        piecesSplit[id].flight = event.target.value;
        break;
    }
    this.setState({ piecesSplit });
  };

  changeDate = (date: any): void => {
    this.setState({ date: date }, () => {
      this.fetchPendingScreenings();
    });
  };

  selectDate = (date: Date, index: number, type: string): void => {
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    if (type === 'flight') {
      piecesSplit[index].flightDate = moment(date).format("DD MMM YY");
    } else {
      piecesSplit[index].date_time = moment(date).format("YYYYMMDD");
    }
    this.setState({ piecesSplit });
  };

  selectBkdFlight = (event: any) => {
    const id: number = event.target.id;
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    piecesSplit[id].checked = !piecesSplit[id].checked;
    if (piecesSplit[id].checked) {
      piecesSplit[id].flight = this.state.awb[0].export_metadata.firstFlightNumber;
      piecesSplit[id].flightDate = moment(this.state.awb[0].export_metadata.firstFlightDate).format("DD MMM YY");
    } else {
      piecesSplit[id].flight = '';
      piecesSplit[id].flightDate = null;
    }
    this.setState({ piecesSplit });
  }

  handleDateChange = (date: any, index: number): void => {
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    piecesSplit[index].time = moment(date).format("HH:mm:ss");
    this.setState({ piecesSplit });
  };

  submitScreening = (event: any, i: number): void => {
    event.preventDefault();
    const screeningItem: Screening = this.state.piecesSplit[i];
    let alarm = false;
    if (screeningItem.alarm && !screeningItem.alarm_resolution) {
      alarm = true;
    }
    if (!screeningItem.pieces || !screeningItem.flight || !screeningItem.measure_applied || !screeningItem.screening_details || alarm) {
      return;
    }
    screeningItem.flight = screeningItem.flight.trim() + '/' + screeningItem.flightDate;
    delete screeningItem.disabled;
    delete screeningItem.checked;
    delete screeningItem.flightDate;
    if (screeningItem.id) {
      screeningRemote
        .updateScreening(this.state.code, this.state.number, this.state.awbVersion, screeningItem, this.state.orderNumber)
        .then((res: ApiResponse<boolean>) => {
          const result: any | undefined = res.result;
          const error: ResponseError | undefined = res.error;

          if (result) {
            const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
            piecesSplit[i].disabled = true;
            piecesSplit[i].flightDate = moment(piecesSplit[i].flight.split('/')[1]).format("DD MMM YY");
            piecesSplit[i].flight = piecesSplit[i].flight.split('/')[0];
            this.setState({ piecesSplit });
            this.searchAwb();
          }

          if (error) {
            this.props.receiveError(error);
          }
        });
    } else {
      screeningRemote
        .insertScreening(this.state.code, this.state.number, this.state.awbVersion, screeningItem, this.state.orderNumber)
        .then((res: ApiResponse<number>) => {
          const result: any | undefined = res.result;
          const error: ResponseError | undefined = res.error;

          if (result) {
            const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
            piecesSplit[i].id = result;
            piecesSplit[i].flightDate = moment(screeningItem.flight.split('/')[1]).format("DD MMM YY");
            piecesSplit[i].flight = piecesSplit[i].flight.split('/')[0];
            piecesSplit[i].disabled = true;
            this.setState({ piecesSplit });
            this.searchAwb();
          }

          if (error) {
            this.props.receiveError(error);
          }
        });
    }

  };

  getExemptions = (): void => {
    screeningRemote.getScreeningExemptions(this.state.code, this.state.number, this.state.awbVersion).then((res: ApiResponse<ScreeningResponse>) => {
      if (res.result) {
        const measures: Array<string> = res.result.measure.measures;
        const exemptions: Exemption = res.result.exemptions;
        const alarmResolutions: Array<string> = res.result.alarm_resolution ? res.result.alarm_resolution.resolution : [];
        this.setState({ measures, exemptions, alarmResolutions });
      }

      if (res.error) {
        this.props.receiveError(res.error);
      }
    });
  }

  deleteCard = (index: number): void => {
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    const item: Screening = piecesSplit[index];
    if (item.id) {
      screeningRemote
        .deleteScreening(this.state.code, this.state.number, this.state.awbVersion, item.id, this.state.orderNumber)
        .then((res: ApiResponse<number>) => {
          if (res.result) {
            piecesSplit.splice(index, 1);
            this.setState({ piecesSplit });
          }

          if (res.error) {
            this.props.receiveError(res.error);
          }
        });
    }
  };

  screenedCheck = (index: number): void => {
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    piecesSplit[index].userCheckBox = !piecesSplit[index].userCheckBox;
    this.setState({ piecesSplit });
  }

  editCard = (index: number): void => {
    const piecesSplit: Array<Screening> = [...this.state.piecesSplit];
    piecesSplit[index].disabled = false;
    this.setState({ piecesSplit });
  };

  clearScreening = (): void => {
    this.setState({
      awb: [],
      forwarder: {} as Forwarder,
      pickupOrders: [],
      awbNumber: "",
      piecesSplit: [],
      code: "",
      number: "",
      originDest: [],
      exportDetails: [],
      isAttachmentsDialogOpen: false,
      orderNumber: ''
    }, () => {
      this.fetchPendingScreenings();
    });
  };

  handleOpenModal = (): void => {
    this.setState({ isAttachmentsDialogOpen: true });
  };

  screenAwb = (code: string, number: string, version: number, orderNumber?: string): void => {
    this.setState({ awbNumber: code + '-' + number, awbVersion: version, orderNumber: orderNumber ? orderNumber : '' }, () => {
      this.searchAwb();
    });
  }

  handleCloseModal = (): void => {
    this.setState({ isAttachmentsDialogOpen: false });
  };

  confirmAwb = (): void => {
    const awb = this.state.selectedAwb;
    this.setState({ awbVersion: awb.version, multipleAwbModal: false }, () => {
      this.searchAwb();
    });
  }

  selectAwb = (awb: Awb): void => {
    this.setState({ selectedAwb: awb, awbVersion: awb.version });
  }

  search = (): void => {

    if (validation.validateAWB(this.state.awbNumber)) {
      awbRemote.getAwbs(this.state.awbNumber).then(resp => {
        const awbsInfo: any | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (error) {
          this.props.receiveError(error);
        }
        if (awbsInfo.awbs.length < 2) {
          this.searchAwb();
        } else {
          if (awbsInfo.awbs) {
            this.setState({ multipleAwbModal: true, multipleAwbs: awbsInfo.awbs });
          }
        }


      });
    }
  }

  fetchPendingScreenings = (): void => {
    let startDate: string = this.state.date.format('YYYYMMDD');
    screeningRemote.getPendingAwbs(startDate).then((resp: ApiResponse<Array<PendingAwbs>>) => {
      const awbs: Array<PendingAwbs> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awbs) {
        this.setState({ pendingAwbs: awbs });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  searchAwb = (): void => {
    if (validation.validateAWB(this.state.awbNumber)) {
      this.props.setButtonState(true);
      const awbParams: AwbParams = extractAwbCodeAndNumber(
        this.state.awbNumber
      );

      screeningRemote
        .getScreeningAwb(awbParams.awbCode, awbParams.awbNumber, this.state.awbVersion, this.state.orderNumber)
        .then((res: ApiResponse<ScreeningAwbDetails>) => {
          this.props.setButtonState(false);
          const result: any | undefined = res.result;
          const error: ResponseError | undefined = res.error;
          let screen: Array<Screening>;
          if (result.multipleOrders) {
            this.setState({ multipleOrders: result.orders, showOrderSelectionPopup: true });
          }
          else {
            const flight: string = result.awb.export_metadata.firstFlightNumber.substring(0, 2);
            const fullFlight: string = result.awb.export_metadata.firstFlightNumber +
              "/" + moment(result.awb.export_metadata.firstFlightDate)
                .format("DD-MMM-YY")
                .toUpperCase();
            const today: Date = new Date();
            let checked: boolean = true;
            let bkdFlight: string = result.awb.export_metadata.firstFlightNumber;
            let flightDate: any = moment(result.awb.export_metadata.firstFlightDate).format("DD MMM YY");
            if (flight === 'PO') {
              checked = false;
              bkdFlight = '';
              flightDate = null;
            }
            screen = [
              {
                pieces: 0,
                measure_applied: "",
                screening_details: "",
                flight: bkdFlight,
                flightDate: flightDate,
                details: "",
                disabled: false,
                checked: checked,
                date_time: moment(today).format("YYYYMMDD"),
                time: moment(today).format("HH:mm:ss"),
                screened_by: "",
                alarm: false,
                alarm_resolution: '',
                actual_weight: 0
              },
            ];
            screen[0].pieces = result.awb.pieces;

            const originDest: Array<KeyValue> = [];
            const exportDetails: Array<KeyValue> = [];
            screen[0].screened_by = `${this.props.user.firstName} ${this.props.user.lastName}`;
            Object.keys(result.awb).map((keyName: string) => {
              if (keyName === 'origin') {
                originDest.push({
                  key: 'ORIGIN', val: result.awb[keyName]
                });
              } else if (keyName === 'destination') {
                originDest.push({
                  key: 'DEST', val: result.awb[keyName]
                });
              }
            });

            Object.keys(result.awb.export_metadata).map((keyName: string) => {
              if (keyName === 'comodityType') {
                exportDetails.push({
                  key: 'COMM', val: result.awb.export_metadata[keyName]
                });
              }
            });

            if (result.screening.length > 0) {
              screen = result.screening;
              screen.forEach((el: Screening) => {
                el.flightDate = moment(el.flight.split('/')[1]).format("DD MMM YY");
                el.flight = el.flight.split('/')[0];
                el.disabled = true;
              });
            }
            this.setState({
              awb: [result.awb],
              originDest,
              flight,
              fullFlight,
              exportDetails,
              forwarder: result.forwarder,
              pickupOrders: result.pickupOrders,
              code: awbParams.awbCode,
              number: awbParams.awbNumber,
              piecesSplit: screen,
              disableScreening: result.pickupOrders[0] && result.pickupOrders[0].returned_awb_date ? true : false
            }, () => {
              this.getExemptions();
            });
          }

          if (error) {
            this.props.receiveError(error);
          }
        });
    } else {
      const errObj: ResponseError = {
        errorCode: "",
        longDescription:
          "The entered value should contain a code (3 digits) and a number (8 digits) separated by a dash (-)!",
      };
      this.props.receiveError(errObj);
    }
  };

  handleOrderSelect = (order: any) => {
    // Implement logic to handle order selection
    this.setState({ showOrderSelectionPopup: false, orderNumber: order.number }, () => {
      this.searchAwb();
    });
    // Continue fetching the screening details using the selected order
  };

  render() {

    return (
      <div className={screeningStyles.mainContainer}>
        <div className={commonStyles.searchWrapperOuter}>
          <AwbInfoSearchComponent
            awbNumber={this.state.awbNumber}
            label='AirwayBill'
            handleChangeAwbNumber={this.handleChangeAwb}
            search={this.search}
            type='screening'
            buttonState={this.props.buttonState}
          />
        </div>
        <div className={[screeningStyles.flex, screeningStyles.searchBlock].join(" ")}>
          {this.state.awb.length === 0 && (
            <PendingScreeningTable
              screenAwb={this.screenAwb}
              awbs={this.state.pendingAwbs}
              date={this.state.date}
              dateChange={this.changeDate}
            />
          )
          }
          {this.state.number && (
            <div className={screeningStyles.clearBtnOuter}>
              <Button
                color="primary"
                variant="contained"
                onClick={this.clearScreening}
                className={screeningStyles.button}
              >
                Clear
              </Button>
            </div>
          )}

          {this.state.fromWarehouse && (
            <div className={screeningStyles.clearBtnOuter}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => this.props.history.goBack()}
                className={screeningStyles.button}
              >
                Back to whs
              </Button>
            </div>
          )}
        </div>
        <div
          className={[screeningStyles.flex, screeningStyles.alignTop, screeningStyles.flexCol].join(" ")}
        >
          {this.state.awb.length > 0 && (
            <ScreeningAwbInfoComponent
              pickupOrders={this.state.pickupOrders}
              awbNumber={this.state.awbNumber}
              fullFlight={this.state.fullFlight}
              awb={this.state.awb[0]}
              originDest={this.state.originDest}
              exportData={this.state.exportDetails}
              forwarder={this.state.forwarder}
              handleOpenModal={this.handleOpenModal}
            />
          )}
          {this.state.awb.length > 0 && (
            <ScreeningDetailsComponent
              piecesSplit={this.state.piecesSplit}
              flight={this.state.flight}
              changePieces={this.changePieces}
              changeDetails={this.changeText}
              selectDate={this.selectDate}
              selectFlight={this.selectBkdFlight}
              submitScreening={this.submitScreening}
              handleDateChange={this.handleDateChange}
              editCard={this.editCard}
              deleteCard={this.deleteCard}
              addCard={this.addCard}
              handleSelectChange={this.handleSelectChange}
              measures={this.state.measures}
              exemptions={this.state.exemptions}
              alarmResolutions={this.state.alarmResolutions}
              setUserManually={this.screenedCheck}
              awbNumber={this.state.awbNumber}
              awbVersion={this.state.awbVersion}
              orderNumber={this.state.orderNumber}
              disableScreening={this.state.disableScreening}
              errorMessage={this.state.errorMessage}
            />
          )}

          {this.state.isAttachmentsDialogOpen && (
            <AttachmentsContainer
              code={this.state.code}
              number={this.state.number}
              version={this.state.awbVersion}
              checked={this.state.isAttachmentsDialogOpen}
              closeAttachments={() => this.handleCloseModal()}
              refreshAwbs={true}
            />
          )}

          {this.state.multipleAwbModal &&
            <MultipleAwbs
              modalOpen={this.state.multipleAwbModal}
              handleClose={this.handleCloseModal}
              awbHistory={this.state.multipleAwbs}
              proceed={this.confirmAwb}
              selectAwb={this.selectAwb}
              awb={this.state.selectedAwb}
              user={this.props.user}
            />
          }
          <OrderSelectionPopup
            open={this.state.showOrderSelectionPopup}
            orders={this.state.multipleOrders}
            onSelect={this.handleOrderSelect}
            onClose={() => this.setState({ showOrderSelectionPopup: false })}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    buttonState: state.buttonState
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    setButtonState: (value: boolean) => dispatch(receiveButtonState(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningDetailsContainer);
